export class GetMenusBO {
  sideMenuId: string = "00000000-0000-0000-0000-000000000000";
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string;
  orderType: string = "asc";
  type: string = "string";
  field: string;
  operator: string = "startswith";
  value: string = "";
  agencyID: string = "00000000-0000-0000-0000-000000000000";
  matchCase: boolean = false;
}

export class saveMenusBo {
  id: string = "00000000-0000-0000-0000-000000000000";
  title: string;
  icon: string;
  link: string;
  menuCode: string;
  parentMenuItemId: string | null;
  orderNumber: number;
  isFunctionRequired: boolean;
  isEvv: boolean = false;
  isSuperAdminExclusive: boolean = false;
}


export class saveFunctionBo {
  id: string = "00000000-0000-0000-0000-000000000000";
  sideMenuItemsId: string;
  functionCode: string;
  functionName: string;
  menuName: string;
  orderNumber: number;
  isEvv: boolean = false;
}

export class sideMenuItemsIdBo {
  Id: string;
  FunctionName: string = "";
}

export class functionpermission {
  menucreate: boolean = true
  menuupdate: boolean = true

}
